// 檔案 API 用同一個 api client（帶登入 token、401 自動回登入頁）
import api from './api';

export interface PMFile {
  id: string;
  projectId: string;
  organizationId: string;
  fileName: string;
  fileSize: number;
  mimeType: string;
  storagePath: string;
  storageType: 'LOCAL' | 'SUPABASE';
  requirementId?: string;
  taskId?: string;
  milestoneId?: string;
  uploadedBy: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export interface UploadFileParams {
  file: File;
  projectId: string;
  description?: string;
  requirementId?: string;
  taskId?: string;
  milestoneId?: string;
}

export interface UploadFileResult {
  id: string;
  fileName: string;
  fileSize: number;
  mimeType: string;
  storagePath: string;
  storageType: 'LOCAL' | 'SUPABASE';
}

/**
 * 上傳檔案
 */
export const uploadFile = async (params: UploadFileParams): Promise<UploadFileResult> => {
  const formData = new FormData();
  formData.append('file', params.file);
  formData.append('projectId', params.projectId);

  if (params.description) {
    formData.append('description', params.description);
  }
  if (params.requirementId) {
    formData.append('requirementId', params.requirementId);
  }
  if (params.taskId) {
    formData.append('taskId', params.taskId);
  }
  if (params.milestoneId) {
    formData.append('milestoneId', params.milestoneId);
  }

  const response = await api.post<UploadFileResult>('/files/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

/**
 * 取得專案檔案列表
 */
export const getProjectFiles = async (projectId: string): Promise<PMFile[]> => {
  const response = await api.get<PMFile[]>(`/files/project/${projectId}`);
  return response.data;
};

/**
 * 刪除檔案
 */
export const deleteFile = async (fileId: string): Promise<void> => {
  await api.delete(`/files/${fileId}`);
};

/**
 * 以帶認證的請求取得檔案內容（用於圖片顯示與下載）
 */
export const fetchFileBlob = async (fileId: string): Promise<Blob> => {
  const response = await api.get<Blob>(`/files/${fileId}/download`, { responseType: 'blob' });
  return response.data;
};

/**
 * 格式化檔案大小（無小數點）
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return Math.round(bytes / Math.pow(k, i)) + ' ' + sizes[i];
};

